import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/styles.css";
import "./styles/variables.css";
import "./styles/theme.css";
import "./styles/bootstrap-theme-override.css";
import "./styles/theme-buttons.css";
import "./styles/layout.css";
import "./styles/components.css";
import App from "./App";
import { AppProvider } from "./APIHelpers/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppProvider>
    <App />
  </AppProvider>,
);

